import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumberFormat'
})
export class CustomNumberFormatPipe implements PipeTransform {

  transform(value: number, digitBeforeDecimal: number, digitAfterDecimal: number): string {
    value = value ?? 0;
    const roundedValue = value.toFixed(digitAfterDecimal);

    let stringValue = roundedValue.toString();

    const parts = stringValue.split('.');

    parts[0] = parts[0].padStart(digitBeforeDecimal, '0');

    parts[1] = parts[1] ? parts[1].slice(0, digitAfterDecimal).padEnd(digitAfterDecimal, '0') : '0'.repeat(digitAfterDecimal);

    return parts.join('.');
  }

}
